import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";

export type CreateExpenseUnitFormValues = {
  name: string;
  symbol: string;
  unit_type: string;
};

export type UpdateExpenseUnitFormValues = {
  id: string;
} & CreateExpenseUnitFormValues;

export const getExpenseUnits = async (config?: AxiosRequestConfig) => {
  const params = config?.params;

  if (params?.sort) {
    params.sort = JSON.stringify(params.sort);
  }

  if (params?.filters) {
    params.filters = JSON.stringify(params.filters);
  }

  const response = await axiosInstance.get("/units", config);
  return response.data;
};

export const createExpenseUnit = async (data: CreateExpenseUnitFormValues) => {
  const response = await axiosInstance.post("/units", data);
  return response.data;
};

export const updateExpenseUnit = async (
  id: string,
  data: UpdateExpenseUnitFormValues
) => {
  const response = await axiosInstance.put(`/units/${id}`, data);
  return response.data;
};

export const deleteExpenseUnit = async (id: string) => {
  const response = await axiosInstance.delete(`/units/${id}`);
  return response.data;
};

export const restoreExpenseUnit = async (id: string) => {
  const response = await axiosInstance.post(`/units/${id}/reactivate`);
  return response.data;
};
